import React from 'react';

// A tiny, dependency-free line-icon set (stroke = currentColor) so we can retire
// the emoji feature icons without pulling in a whole icon package for six glyphs.
// Add new glyphs here as needed; keep them single-stroke and on the 24x24 grid.
export type IconName =
  | 'mic' | 'brain' | 'check-circle' | 'clipboard' | 'heart' | 'lock'
  | 'sparkle' | 'play' | 'arrow-right';

const PATHS: Record<IconName, React.ReactNode> = {
  mic: (<><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" /><path d="M19 10v2a7 7 0 0 1-14 0v-2" /><line x1="12" y1="19" x2="12" y2="23" /><line x1="8" y1="23" x2="16" y2="23" /></>),
  brain: (<><path d="M12 5a2.6 2.6 0 0 0-5 -.9A2.5 2.5 0 0 0 4.4 6.7 2.6 2.6 0 0 0 4.4 11 2.6 2.6 0 0 0 6 15.5 2.5 2.5 0 0 0 9.4 18c1.4 0 2.6-1.1 2.6-2.5V5Z" /><path d="M12 5a2.6 2.6 0 0 1 5 -.9A2.5 2.5 0 0 1 19.6 6.7 2.6 2.6 0 0 1 19.6 11 2.6 2.6 0 0 1 18 15.5 2.5 2.5 0 0 1 14.6 18c-1.4 0-2.6-1.1-2.6-2.5V5Z" /></>),
  'check-circle': (<><circle cx="12" cy="12" r="9" /><polyline points="8.5 12.5 11 15 16 9" /></>),
  clipboard: (<><rect x="8" y="4" width="8" height="4" rx="1" /><path d="M8 6H6a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-2" /><line x1="9" y1="13" x2="15" y2="13" /><line x1="9" y1="17" x2="13" y2="17" /></>),
  heart: (<path d="M12 20s-7-4.5-9.5-9A4.6 4.6 0 0 1 12 6a4.6 4.6 0 0 1 9.5 5c-2.5 4.5-9.5 9-9.5 9Z" />),
  lock: (<><rect x="4" y="10" width="16" height="10" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></>),
  sparkle: (<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z" />),
  play: (<polygon points="7 4 20 12 7 20 7 4" />),
  'arrow-right': (<><line x1="4" y1="12" x2="19" y2="12" /><polyline points="13 6 19 12 13 18" /></>),
};

interface Props { name: IconName; size?: number; strokeWidth?: number; style?: React.CSSProperties; className?: string; }

export default function Icon({ name, size = 22, strokeWidth = 1.8, style, className }: Props) {
  return (
    <svg
      viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor"
      strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" focusable="false" style={style} className={className}
    >
      {PATHS[name]}
    </svg>
  );
}
